import { Component, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { ModalController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-successful-payment',
    templateUrl: './payment-successful-charge.component.html',
    styleUrls: ['./payment-successful-charge.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, RouterModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PaymentSuccessfulChargeComponent implements OnInit {
    constructor(private modalCtrl: ModalController) {}

    @Input() type: string;

    faCheckCircle = faCheckCircle;

    ngOnInit() {
        /* empty */
    }

    close() {
        this.modalCtrl.dismiss();
    }
}
